import React from 'react';

const UpgradeDeliveryCallback = ({ match, location, history }) => {
  const status = match.params.status;
  const xltID = (location && location.state && location.state.xltID) || '';
  const hawb = (location && location.state && location.state.hawb) || '';
  const parcelAddress = (location && location.state && location.state.address) || '';
  console.log(`UpgradeDeliveryCallbackPage status ${status}, xltID=${xltID}, hawb=${hawb}, parcelAddress? ${!!parcelAddress}`);

  function renderContent() {
    if (status === 'success' && parcelAddress) {
      return (
        <>
          <h1>
            המשלוח שודרג בהצלחה!
          </h1>
          <strong className='sms-message'>
            המשלוח ישלח לכתובת:
          </strong>
          <div className='address-wrap'>
            {parcelAddress.stAddress}<br />
            {parcelAddress.city} {parcelAddress.zip}
          </div>
          <p style={{ marginTop: '25px' }}>
            <strong>מס’ למעקב: </strong>
            <span>&nbsp; {hawb}</span>
          </p>
          <button className='btn medium orange centered' onClick={() => history.push(`/tracking/${hawb}`)}>מעקב משלוח</button>
        </>
      );
    }

    if (status === 'error') {
      return (
        <div className='sms-message'>
          <h1>
            ארעה שגיאה בביצוע התשלום {location.state && location.state.body && location.state.body.ErrorText && `(${location.state.body.ErrorText})`}.<br />
            אנא נסו שוב או צרו קשר עם שירות הלקוחות.
          </h1>
          {location.state && location.state.body && location.state.body.ErrorCode && `קוד שגיאה: ${location.state.body.ErrorCode}`}
        </div>
      );
    }

    if (status === 'cancelled') {
      return (
        <div className='sms-message'>
          <h1>
            השדרוג בוטל.
          </h1>
        </div>
      );
    }

    console.error(`Unexpected status ${status}`);
    return null;
  }

  return (
    <div className='sms-content-wrap'>
      {renderContent()}
    </div>
  );
};

export { UpgradeDeliveryCallback };
